import {Show} from 'solid-js'
import './loginQrForm.css'
import {QRCodeCanvas} from 'solid-qr-code'
import {useConfig} from '../config/useConfig'

const LoginQrForm = () => {
    const {getConfig} = useConfig()

    return (
        <div>
            <Show when={getConfig().userAuthType === 'BOTH'}>
                <div class="user-name-qr-heading">Scan QR Code</div>
            </Show>
            <div class="qr-code-container">
                <QRCodeCanvas
                    value={'https://picturesofpeoplescanningqrcodes.tumblr.com/'}
                    title={'Title for my QR Code'}
                    size={2000}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}
                    marginSize={31}
                    imageSettings={{
                        src: 'https://static.zpao.com/favicon.png',
                        x: 100,
                        y: 100,
                        height: 1000,
                        width: 1000,
                        opacity: 0.4,
                        excavate: false,
                    }}
                />
            </div>
            <div class="qr-description">Scan the QR code with your mobile or tablet to log in</div>
        </div>
    )
}

export default LoginQrForm
